module.exports = __webpack_public_path__ + "static/album-cover.320836c3.jpg";


//////////////////
// WEBPACK FOOTER
// /tmp/build_2cb81483/src/assets/images/home/album-cover.jpg
// module id = 1318
// module chunks = 4